import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './BusinessPortfolios.module.css';
import { API_BASE_URL } from '../../config';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import ModernNavbarPureCSS from "../../components/Navbar/ModernNavBarPureCSS";
import jobstyles from "../JobDashboard/NewHomeUserJobsDashboard.module.css";

const BusinessPortfoliosDashboard = () => {
    const [portfolios, setPortfolios] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [username, setUsername] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decodeToken = jwtDecode(token);
            setUsername(decodeToken.UserName || 'User');
        }

        const fetchPortfolios = async () => {
            setIsLoading(true);
            try {
                const loggedInBusinessId = localStorage.getItem('loggedInBusinessId');
                const businessId = loggedInBusinessId;
                if (!businessId) {
                    setError("Business ID not found. Please log in as a business user.");
                    setIsLoading(false);
                    return;
                }

                const response = await axios.get(`${API_BASE_URL}/api/WorkPortfolio/WorkPortfolios?businessId=${businessId}`);
                if (response.data && Array.isArray(response.data.model)) {
                    setPortfolios(response.data.model);
                } else {
                    setPortfolios([]);
                }
            } catch (err) {
                setError('Failed to fetch work portfolios. Please try again.');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPortfolios();
    }, []);

    return (
        <div className={jobstyles.jobDashboard_minHeightScreen + ' ' + jobstyles.jobDashboard_bgGradientBlueAmber}>
            
            <ModernNavbarPureCSS UserName={username} prefix={''} TabActiveId={'portfolios'} />

            <header className={jobstyles.jobDashboard_bgGradientHeader + ' ' + jobstyles.jobDashboard_header} style={{ position: 'sticky', top: 0, zIndex: 1020 }}>
                <div className={jobstyles.jobDashboard_container}>
                    <div className={jobstyles.bizjobDashboard_headerContent}>
                        <div className={jobstyles.jobDashboard_headerLeft}>
                            <div className={jobstyles.jobDashboard_headerLogo}>
                                <h1 className={jobstyles.jobDashboard_text2xl + ' ' + jobstyles.jobDashboard_fontBold}>Portfolio Dashboard</h1>
                            </div>
                        </div>
                        <Link to="/business-portfolios/new" className={styles.createButton}>
                            Create Work Portfolio
                        </Link>
                    </div>
                </div>
            </header>

            <div className={jobstyles.jobDashboard_container + ' ' + jobstyles.jobDashboard_py8}>
                {isLoading && <p>Loading...</p>}
                {error && <p className={styles.error}>{error}</p>}

                {!isLoading && !error && portfolios.length === 0 && (
                    <p>No work portfolios found.</p>
                )}

                {!isLoading && !error && portfolios && portfolios.length > 0 && (
                    <div className={styles.jobList}>
                        {portfolios.map((portfolio) => (
                            <Link to={`/business-portfolios/${portfolio.portfolioId}`} key={portfolio.portfolioId} className={styles.jobCardLink}>
                                <div className={styles.jobCard}>
                                    <div className={styles.jobCardImage}>
                                        <img src={portfolio.mediaUrl && portfolio.mediaUrl.length > 0 ? portfolio.mediaUrl[0].url : 'https://via.placeholder.com/150'} alt={portfolio.title} />
                                    </div>
                                    <div className={styles.jobCardContent}>
                                        <h3>{portfolio.title}</h3>
                                        <p>{portfolio.description}</p>
                                        <div className={styles.jobCardFooter}>
                                            <span>{portfolio.suburb}, {portfolio.postcode}</span>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BusinessPortfoliosDashboard;
